import React from 'react';
import { Table, Tag, Button, Space, Popconfirm, message } from 'antd';

const PartnerList = ({ partners = [], onEdit, onDelete }) => {
    const columns = [
        {
            title: 'Tên đối tác',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Mã đối tác',
            dataIndex: 'code',
            key: 'code',
            render: code => <Tag color="geekblue">{code}</Tag>
        },
        {
            title: 'Token',
            dataIndex: 'token',
            key: 'token',
        },
        {
            title: 'Trạng thái',
            dataIndex: 'active',
            key: 'active',
            render: active => <Tag color={active ? 'green' : 'red'}>{active ? 'Hoạt động' : 'Ngừng'}</Tag>
        },
        {
            title: 'Hành động',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Button type="link" onClick={() => onEdit?.(record)}>Sửa</Button>
                    <Popconfirm
                        title="Bạn có chắc chắn muốn xóa đối tác này không?"
                        onConfirm={() => {
                            onDelete?.(record);
                            message.success('Đã xóa đối tác');
                        }}
                        okText="Xóa"
                        cancelText="Hủy"
                    >
                        <Button type="link" danger>Xóa</Button>
                    </Popconfirm>
                </Space>
            )
        }
    ];

    const dataSource = partners.map((p, i) => ({
        ...p,
        key: p.id || i
    }));

    return (
        <div style={{ padding: 16 }}>
            <h2>Danh sách đối tác</h2>
            <Table columns={columns} dataSource={dataSource} bordered pagination={{ pageSize: 10 }} />
        </div>
    );
};

export default PartnerList;
